import React from 'react';
import PropTypes from 'prop-types';
import css from './EditInfo.css';
import Icon from 'SF/MaterialIcon';

const EditInfo = ({message}) => (
  <div className={css['container']}>
    <Icon aria-hidden="true" icon="info"/>
    <div className={css['message']} data-role="alertAccessMessage">{message}</div>
  </div>
);

EditInfo.propTypes = {
  message: PropTypes.string.isRequired,
};

export default EditInfo;
